  import axios from '@/service/request';
  import type { R } from './types';

  /**
   * 文件上传请求参数
   */
  export interface FileUploadRequest {
    /** 文件 */
    file?: File;
  }


  export default (data: FormData): Promise<R<string>> => {
    return axios.post('/file/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };